enum ComponentType {

  AGGREGATOR = 'Aggregator',
  BEHAVIOR = 'Behavior',
  DATA_DISPLAY = 'DataDisplay',
  DATA_ENTRY = 'DataEntry',
  FEEDBACK = 'Feedback',
  FORM = 'Form',
  LAYOUT = 'Layout',
  LIST = 'List',
  NAVIGATION = 'Navigation',
  
}

export default ComponentType;
